"use strict";

import api from "vwa/api";
import sleep from "vwa/sleep";
import dispatcher from "./../dispatcher";
import {getUser} from "./../utils/user";

const SLEEP_TIME = 5000;

export default async function getUsers() {
	const user = getUser();
	if (!user || !user.groups || user.groups.length === 0) {
		dispatcher.dispatch('getUsers', [user]);
		return;
	}
	
	try {
		const response = await api.get('users', {
			_id: user.groups,
			resolveGroups: true
		});
		dispatcher.dispatch('getUsers', response.users);
	} catch (error) {
		if ("id" in error) {
			await sleep(SLEEP_TIME);
			getUsers();
		} else {
			throw error;
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/getUsers.js